import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Map,
  Building2,
  DollarSign,
  Ship,
  MapPin,
  Users,
  Truck,
  type LucideIcon,
} from 'lucide-react';

export interface NavigationItem {
  icon: LucideIcon;
  text: string;
  path: string;
  ariaLabel?: string;
}

export interface NavigationSection {
  label: string;
  items: NavigationItem[];
}

export const navigationSections: NavigationSection[] = [
  {
    label: "Sailing",
    items: [
      {
        icon: DollarSign,
        text: "Pricing",
        path: "/pricing",
        ariaLabel: "Navigate to Pricing page",
      },
      {
        icon: Map,
        text: "Routes",
        path: "/routes",
        ariaLabel: "Navigate to Routes page",
      },
      {
        icon: Building2,
        text: "Ship Companies",
        path: "/ship-companies",
        ariaLabel: "Navigate to Ship Companies page",
      },
      {
        icon: Ship,
        text: "Vessels",
        path: "/vessels",
        ariaLabel: "Navigate to Vessels page",
      },
      {
        icon: MapPin,
        text: "Ports",
        path: "/ports",
        ariaLabel: "Navigate to Ports page",
      },
      {
        icon: Users,
        text: "Agents & Bookings",
        path: "/agents",
        ariaLabel: "Navigate to Agents page",
      },
    ],
  },
  {
    label: "Cartage",
    items: [
      {
        icon: DollarSign,
        text: "Transport Pricing",
        path: "/transport-pricing",
        ariaLabel: "Navigate to Transport Pricing page",
      },
      {
        icon: Truck,
        text: "Truck Companies",
        path: "/truck-companies",
        ariaLabel: "Navigate to Truck Companies page",
      },
    ],
  },
];

export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToPath = useCallback((path: string) => {
    navigate(path);
  }, [navigate]);

  const isActivePath = useCallback((path: string) => {
    if (path === "/pricing") {
      return location.pathname === "/" || location.pathname.startsWith("/pricing");
    }
    return location.pathname.startsWith(path);
  }, [location.pathname]);

  return {
    navigationSections,
    navigateToPath,
    isActivePath,
    currentPath: location.pathname,
  };
};
